module.exports = __webpack_public_path__ + "static/media/051-Ocean Park Pub.0914dd54.jpg";